import styled from "styled-components";

import Button from "./Button";

const SIBLING_COUNT = 1;
const BOUNDARY_COUNT = 1;

const Styled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;

    span {
        align-self: center;
        user-select: none;
    }
`;

export default function Pagination(props) {
    const { count, current, setPage, ...restProps } = props;
    return (
        <Styled { ...restProps }>
            <Button
                disabled={ current === 1 }
                onClick={ () => setPage(current - 1) }
            >Previous</Button>
            {
                Array
                    .from({ length: count })
                    .map((_, i) => i + 1)
                    .filter(
                        (i) => {
                            if (i === current) return true;

                            if (i <= BOUNDARY_COUNT) return true;
                            if (i > count - BOUNDARY_COUNT) return true;

                            if (current - SIBLING_COUNT <= i && i <= current + SIBLING_COUNT) return true;
                        }
                    )
                    .map(
                        (n, index, array) => (
                            index !== 0
                            && array[index - 1] !== n - 1
                        )
                            ? ["", n]
                            : n
                    )
                    .flat()
                    .map(
                        (i, index) => {
                            if (i === "") return <span key={ `gap-${ index }` }>...</span>;
                            return (
                                <Button
                                    $appearance={ i === current ? "primary" : "subtle" }
                                    key={ i }
                                    onClick={ () => setPage(i) }
                                >{ i }</Button>
                            );
                        }
                    )
            }
            <Button
                disabled={ current === count }
                onClick={ () => setPage(current + 1) }
                style={ {} }
            >Next</Button>
        </Styled>
    );
}
